import {
  ApplicationFeatureToggles,
  GroupedApplicationsTypes,
} from "@/modules/application/common/enum";
import { useGetApplicationTypesQuery } from "@/modules/application/services";
import { OperationRoutes } from "@/shared/common/constants";
import type { CloudflareAsset } from "@/shared/common/enums";
import { ActionItem, EmptyOrErrorContent } from "@/shared/components";
import { useAppSelector } from "@/shared/hooks";
import { Spinner } from "@ab.uitools/ui-library/components/Spinner";
import { Text } from "@ab.uitools/ui-library/components/Text";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const Applications = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { toggles, isLoaded } = useAppSelector((state) => state.featureToggle);

  const { data: applicationGroups, isFetching } = useGetApplicationTypesQuery(undefined, {
    refetchOnMountOrArgChange: true,
    selectFromResult: ({ data, isFetching }) => {
      const transformed = data
        ? Object.entries(GroupedApplicationsTypes).map(([product, types]) => ({
          title: product,
          types: types.filter(
            (type) =>
              data.includes(type) &&
              toggles?.[ApplicationFeatureToggles[type as string as keyof typeof ApplicationFeatureToggles]],
          ),
        }))
        : [];
      return {
        isFetching,
        data: transformed,
      };
    },
  });

  return (
    <div className="mb-32 applications-grid-wrapper">
      {isFetching || !isLoaded ? (
        <div
          className="full-width flexbox justify-content--center loader-wrapper">
          <Spinner isFullScreen={false} size="large"/>
        </div>
      ) : (
        applicationGroups.length ? (
          applicationGroups.map((item) => {
            if (!item.types.length) return;
            return (
              <div key={item.title}>
                <Text size="medium" weight="semibold" className="mt-48">
                  {t(`application.types.${item.title}`)}
                </Text>
                <div className="full-width mt-24 application-list-grid">
                  {item?.types?.map(
                    (item: string) => (
                      <ActionItem
                        key={item}
                        title={t(`application.${item}`)}
                        icon={item as CloudflareAsset}
                        onClick={() => {
                          navigate(OperationRoutes[item]);
                        }}
                      />
                    ))}
                </div>
              </div>
            );
          })
        ) : (
          <div className="pt-40">
            <EmptyOrErrorContent
              isShowButton={false}
              title={t("application.types.emptyTitle")}
            />
          </div>
        )
      )}
    </div>
  );
};
